import React from 'react';

import Link from '../../library/link/link';
import Typography from '../../library/typography/typography';

import { Maybe } from '../../shared/types/graphql-types';

import './product-title.scss';

interface ProductTitleProps {
  brand?: Maybe<string>;
  className?: string;
  link?: Maybe<string>;
  name?: Maybe<string>;
  onClick?: (event: React.SyntheticEvent) => void;
  size?: Maybe<string>;
}

function ProductTitle(props: ProductTitleProps) {
  const { className, link, brand, name, onClick, size } = props;

  if (!brand && !name && !size) {
    return null;
  }

  const children = (
    <>
      {brand && (
        <Typography
          className="product-title__brand"
          styleName="brand"
          tag="span"
          variant="H6"
        >
          {brand}
        </Typography>
      )}

      {name && (
        <Typography
          className="product-title__name"
          styleName="name"
          tag="span"
          variant="H4"
          weight="black"
        >
          {name}
        </Typography>
      )}

      {size && (
        <Typography className="product-title__size" styleName="size" tag="span">
          {size}
        </Typography>
      )}
    </>
  );

  if (link) {
    return (
      <Link
        className={`${className || ''} product-title`}
        onClick={onClick}
        styleName="container"
        to={link}
      >
        {children}
      </Link>
    );
  } else {
    return (
      <div className={`${className || ''} product-title`} styleName="container">
        {children}
      </div>
    );
  }
}

export default ProductTitle;
